import { Vector3 } from "@babylonjs/core/Maths/math.vector.js";
import { Animation } from "@babylonjs/core/Animations/animation.js";
export const createVector3 = (vector) => {
    const { x, y, z } = vector;
    return new Vector3(x, y, z);
};
export class ButtonAnimation {
    static async executeScaleAnimation(scene, control) {
        if (control.animations === null || control.animations.length === 0) {
            const size = control.widthInPixels;
            const maxSize = Math.round(size * 1.5);
            // const left = control.leftInPixels;
            // const minLeft = Math.round(left - (maxSize - size) / 2);
            // const top = control.topInPixels;
            // const minTop = Math.round(top - (maxSize - size) / 2);
            const scaleWidthAnimation = new Animation("scaleWidthAnimation", "widthInPixels", 50, Animation.ANIMATIONTYPE_FLOAT);
            const scaleHeightAnimation = new Animation("scaleHeightAnimation", "heightInPixels", 50, Animation.ANIMATIONTYPE_FLOAT);
            // const leftAnimation = new Animation("leftAnimation", "leftInPixels", 50, Animation.ANIMATIONTYPE_FLOAT);
            // const topAnimation = new Animation("topAnimation", "topInPixels", 50, Animation.ANIMATIONTYPE_FLOAT);
            const sizeKeys = [{ frame: 0, value: size }, { frame: 8, value: maxSize }, { frame: 16, value: size }];
            // const leftKeys = [{frame: 0, value: left}, {frame: 8, value: minLeft}, {frame: 16, value: left}];
            // const topKeys = [{frame: 0, value: top}, {frame: 8, value: minTop}, {frame: 16, value: top}];
            scaleWidthAnimation.setKeys(sizeKeys);
            scaleHeightAnimation.setKeys(sizeKeys);
            // leftAnimation.setKeys(leftKeys);
            // topAnimation.setKeys(topKeys);
            control.animations = [scaleWidthAnimation, scaleHeightAnimation, /*leftAnimation, topAnimation*/];
        }
        const highestFrame = control.animations
            ? Math.max(...control.animations.map(x => x.getHighestFrame()))
            : 0;
        const anim = scene.beginAnimation(control, 1, highestFrame);
        await anim.waitAsync();
    }
}
